export type AppRole = "admin" | "merchant" | "trader";

const ROLE_PRIORITY: readonly AppRole[] = ["admin", "merchant", "trader"];

export function resolveAppRole(
  roles: readonly string[] | null | undefined,
): AppRole | null {
  if (!roles) return null;
  for (const role of ROLE_PRIORITY) {
    if (roles.includes(role)) return role;
  }
  return null;
}

export function homeRouteForRole(role: AppRole): string {
  switch (role) {
    case "admin":
      return "#/admin";
    case "merchant":
      return "#/merchant";
    case "trader":
      return "#/payments";
  }
}

export function homeRouteForRoles(
  roles: readonly string[] | null | undefined,
): string | null {
  const role = resolveAppRole(roles);
  return role ? homeRouteForRole(role) : null;
}

export function routePath(route: string): string {
  const queryStart = route.indexOf("?");
  return queryStart === -1 ? route : route.slice(0, queryStart);
}

export function isRouteAllowedForRole(role: AppRole, route: string): boolean {
  const path = routePath(route);
  switch (role) {
    case "admin":
      return path === "#/admin" || path.startsWith("#/admin/");
    case "merchant":
      return (
        path === "#/merchant" ||
        path === "#/merchant/" ||
        path === "#/merchant/orders" ||
        path === "#/merchant/balance" ||
        path === "#/merchant/withdrawals" ||
        path === "#/merchant/settings" ||
        path === "#/merchant/settings/notifications" ||
        path === "#/merchant/notifications" ||
        /^#\/merchant\/orders\/[^/]+$/.test(path)
      );
    case "trader":
      return (
        path === "#/payments" ||
        path === "#/balance" ||
        path === "#/history" ||
        path === "#/settings" ||
        path === "#/settings/notifications" ||
        path === "#/notifications" ||
        path === "#/deposit-cases"
      );
  }
}
